import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "table"
};
const _hoisted_2 = {
  class: "bg-[#CFD8DC]"
};
const _hoisted_3 = {
  style: {
    "margin-bottom": "0.5rem",
    "border-bottom-width": "2px"
  }
};
const _hoisted_4 = {
  class: "font-semibold"
};
import { convertToFormattedCurrency } from '@/services/utils';
import { ref } from 'vue';
export default {
  __name: 'DataTable',
  props: {
    headers: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const tableDataTotal = ref([{
      InvoiceNumber: '',
      InvoiceDate: '',
      MatterName: '',
      ClientMatterIdAndName: '',
      ClientMatterId: '',
      MatterId: '',
      Expenses: 3500,
      Services: 4000,
      Total: 7500
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("table", _hoisted_1, [_createElementVNode("thead", _hoisted_2, [_createElementVNode("tr", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, header => {
        return _openBlock(), _createElementBlock("th", {
          scope: "col",
          class: "text-black",
          style: {
            "padding": "3px",
            "font-weight": "500",
            "text-transform": "none"
          },
          key: header
        }, _toDisplayString(header.displayName), 1);
      }), 128))])]), _createElementVNode("tbody", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, row => {
        return _openBlock(), _createElementBlock("tr", {
          key: row.InvoiceDate
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, header => {
          return _openBlock(), _createElementBlock("td", {
            key: header.fieldName
          }, [_createElementVNode("span", null, [_createTextVNode(_toDisplayString(['InvoiceNumber', 'ClientMatterIdAndName', 'ClientMatterId', 'MatterId'].includes(header.fieldName) ? row[header.fieldName] : _unref(convertToFormattedCurrency)(row[header.fieldName])), 1), _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1))])]);
        }), 128))]);
      }), 128))]), _createElementVNode("tfoot", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableDataTotal.value, footerRow => {
        return _openBlock(), _createElementBlock("tr", {
          key: footerRow.InvoiceDate
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, header => {
          return _openBlock(), _createElementBlock("td", {
            key: header.fieldName
          }, [_createElementVNode("span", _hoisted_4, [_createTextVNode(_toDisplayString(_unref(convertToFormattedCurrency)(footerRow[header.fieldName], true)), 1), _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))])]);
        }), 128))]);
      }), 128))])]);
    };
  }
};